import { environment } from '../config';

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    gtag: (...args: any[]) => void;
  }
}
export class GtagService {
  public static consent(consent: {
    analytics: boolean;
    marketing: boolean;
  }): void {
    try {
      if (environment.stage !== 'PROD') {
        return;
      }

      window.gtag('consent', 'update', {
        ad_user_data: consent.marketing ? 'granted' : 'denied',
        ad_personalization: consent.marketing ? 'granted' : 'denied',
        ad_storage: consent.marketing ? 'granted' : 'denied',
        analytics_storage: consent.analytics ? 'granted' : 'denied',
        wait_for_update: 500,
      });
    } catch (error) {
      console.error('Failed to consent to Gtag:', error);
    }
  }
}
